import { motion } from "framer-motion";

const PROJECTS = [
  "https://customer-assets.emergentagent.com/job_sefco-roofing/artifacts/izz21ppj_image.png",
  "https://customer-assets.emergentagent.com/job_sefco-roofing/artifacts/2qailx7w_image.png",
  "https://customer-assets.emergentagent.com/job_sefco-roofing/artifacts/2me6qfud_image.png",
  "https://customer-assets.emergentagent.com/job_sefco-roofing/artifacts/xt64qkjf_image.png",
];

export const Gallery = () => {
  return (
    <section id="realisaties" data-testid="gallery-section" className="py-24 md:py-32 bg-sefco-bg">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-16"
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-sefco-blue" />
            <span className="text-sm uppercase tracking-[0.2em] text-zinc-400 font-medium">Ons werk</span>
          </div>
          <h2 className="font-heading font-bold text-white text-3xl sm:text-5xl tracking-tight">Onze Realisaties</h2>
          <p className="mt-5 text-zinc-400 leading-relaxed">
            Een greep uit onze uitgevoerde projecten — van bitumen en EPDM tot dakisolatie op
            woningen, appartementen en bedrijfspanden.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {PROJECTS.map((src, i) => (
            <motion.div
              key={src}
              data-testid={`project-image-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative overflow-hidden border border-neutral-800"
            >
              <img
                src={src}
                alt={`Sefco project ${i + 1}`}
                loading="lazy"
                className="w-full h-72 md:h-96 object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 p-5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <span className="text-xs uppercase tracking-[0.2em] text-sefco-blue font-medium">Realisatie {String(i + 1).padStart(2, "0")}</span>
                <div className="font-heading font-bold text-white text-lg">Plat dak & isolatie</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
